document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
        setInterval(() => {
            document.querySelectorAll('a[href]').forEach((anchor) => {
                var getAnchorUrl = anchor.getAttribute('href');
                if(getAnchorUrl !== '#') {
                    anchor.setAttribute('href', getAnchorUrl.split('?')[0]);
                }
            });
        }, 1000);
    }, 10000);
});